{
    "name": "Ghost Pepper",
    "binomial_name": "",
    "common_names": [],
    "description": "",
    "sun_requirements": "",
    "sowing_method": "",
    "spread": 0,
    "row_spacing": 0,
    "height": 0,
    "growing_degree_days": 0,
    "companions": [],
    "image": "/crops/images/ghost-pepper.jpg",
    "icon": "/crops/icons/ghost-pepper.avif"
}